import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LanguageSelector } from '@/components/LanguageSelector';
import { useLanguage } from '@/hooks/useLanguage';
import { translations } from '@/lib/translations';

export function Navigation() {
  const { language } = useLanguage();
  const t = translations[language];
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path: string) => {
    const pathname = location.pathname;
    if (path === '/') {
      return pathname === '/' || pathname === `/${language}`;
    }
    return pathname.startsWith(path) || pathname.endsWith(path);
  };

  const handleHomeClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === '/') {
      // Se siamo già nella homepage, scrolla in alto
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Altrimenti naviga alla homepage
      navigate('/');
    }
  };

  const handleContactClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === '/') {
      // Se siamo nella homepage, scrolla alla sezione contatti
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Se siamo in altre pagine, naviga alla homepage e poi scrolla
      navigate('/');
      // Aspetta che la navigazione sia completata prima di scrollare
      setTimeout(() => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <nav className="fixed w-full bg-white/80 backdrop-blur-md z-50 shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-8">
            <Link to={language === 'it' ? '/' : `/${language}`} className="flex items-center">
              <img 
                src="/rs-logo.svg" 
                alt="RS International Services" 
                className="h-20"
              />
            </Link>
            <div className="hidden md:flex space-x-6">
              <a 
                href={language === 'it' ? '/' : `/${language}`} 
                onClick={handleHomeClick}
                className={`text-gray-700 hover:text-blue-600 transition-colors ${
                  isActive('/') ? 'text-blue-600 font-semibold' : ''
                }`}
              >
                {t.nav.home}
              </a>
              <a 
                href={language === 'it' ? '/#about' : `/${language}#about`} 
                className="text-gray-700 hover:text-blue-600 transition-colors"
              >
                {t.nav.about}
              </a>
              <a 
                href={language === 'it' ? '/#services' : `/${language}#services`} 
                className="text-gray-700 hover:text-blue-600 transition-colors"
              >
                {t.nav.services}
              </a>
              <Link 
                to={language === 'it' ? '/podcast' : `/${language}/podcast`} 
                className={`text-gray-700 hover:text-blue-600 transition-colors ${
                  isActive('/podcast') ? 'text-blue-600 font-semibold' : ''
                }`}
              >
                {t.nav.podcast}
              </Link>
              <Link 
                to={language === 'it' ? '/blog' : `/${language}/blog`} 
                className={`text-gray-700 hover:text-blue-600 transition-colors ${
                  isActive('/blog') ? 'text-blue-600 font-semibold' : ''
                }`}
              >
                {t.nav.blog}
              </Link>
              <a 
                href={language === 'it' ? '/#contact' : `/${language}#contact`} 
                onClick={handleContactClick}
                className="text-gray-700 hover:text-blue-600 transition-colors"
              >
                {t.nav.contact}
              </a>
            </div>
          </div>
          <LanguageSelector />
        </div>
      </div>
    </nav>
  );
}